"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChargeTypes = void 0;
class ChargeTypes {
    static Manual = 'Manual';
    static SystemGenerated = 'SystemGenerated';
    static Predefined = 'Predefined';
}
exports.ChargeTypes = ChargeTypes;
